import { createRouter, createWebHistory } from "vue-router";
import PageNotFound from "./views/PageNotFound.vue";
import CieloFarol from "./views/CieloFarol.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => {
      window.location = "https://overmediacast.com";
    },
  },
  {
    path: "/not-found",
    name: "pageNotFound",
    component: PageNotFound,
  },
  {
    path: "/cielo-farol",
    name: "CieloFarol",
    component: CieloFarol,
  },
  {
    path: "/:slug",
    name: "slug",
    // eslint-disable-next-line
    component: () => import(/* webpackChunkName: "slug" */ "./views/SlugHandler.vue")
  },
  {
    path: "/m/:slug",
    name: "MajsticSlug",
    // eslint-disable-next-line
    component: () => import(/* webpackChunkName: "slug" */ "./views/SlugHandlerMajestic.vue")
  },
  {
    path: "/:client_name/:video_name",
    name: "brandChannel",
    // eslint-disable-next-line
    component: () => import(/* webpackChunkName: "brandChannel" */ "./views/BrandChannel")
  },
  {
    path: "/v2/:client_name/:video_name",
    name: "brandChannelV2",
    // eslint-disable-next-line
    component: () => import(/* webpackChunkName: "brandChannelV2" */ "./views/V2BrandChannel")
  },
  {
    path: "/m/:client_name/:video_name",
    name: "majesticBrandChannel",
    // eslint-disable-next-line
    component: () => import(/* webpackChunkName: "brandChannelV2" */ "./views/MajesticBrandChannel")
  },
  // fallback
  {
    path: "/:catchAll(.*)",
    redirect: "/not-found",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
